import axios from 'axios';
import { baseURL } from './api';

const apiVersion = 'v2';
export const path = process.env.REACT_APP_BASE_URL + '/api/';
export const localUsers = [
  {
    _id: 1,
    email: 'john@abc.com',
    name: 'John Doe',
    enabled: false,
    phoneNum: '123123',
    registerDate: Date(),
  },
  {
    _id: 2,
    email: 'doe@abc.com',
    name: 'Doe Ber',
    enabled: false,
    phoneNum: '123123',
    registerDate: Date(),
  },
  {
    _id: 3,
    email: 'sam@abc.com',
    name: 'Sam Smith',
    enabled: true,
    phoneNum: '123123',
    registerDate: Date(),
  },
  {
    _id: 4,
    email: 'umu@abc.com',
    name: 'Umu Lee',
    enabled: true,
    phoneNum: '123123',
    registerDate: Date(),
  },
  {
    _id: 5,
    email: 'kira@abc.com',
    name: 'Kir Che',
    enabled: false,
    phoneNum: '123123',
    registerDate: Date(),
  },
  {
    _id: 6,
    email: 'An@abc.com',
    name: 'Ana Marie',
    enabled: false,
    phoneNum: '123123',
    registerDate: Date(),
  },
];

class UserService {
  static baseURL = baseURL;

  static resourcePath = path || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
    this.logout = this.logout.bind(this);
  }

  getBaseURL = () => {
    return this.baseURL || UserService.resourcePath || UserService.baseURL;
  };

  async authenticate(id, password, authMode = 'sms') {
    const loginPath = `${this.getBaseURL()}${apiVersion}/users/authenticate/${JSON.parse(localStorage.getItem('2fa-auth')).id
      }?authMode=${authMode}`;
    const { data } = await axios.post(loginPath, { otp: password });
    return data;
  }

  async sendOtp(id) {
    const smsPath = `${this.getBaseURL()}${apiVersion}/users/sms/${JSON.parse(localStorage.getItem('2fa-auth')).id
      }`;
    const { data } = await axios.post(smsPath);
    return data;
  }

  async sendEmailOtp() {
    const storedId = JSON.parse(localStorage.getItem('2fa-auth')).id;
    const smsPath = `${this.getBaseURL()}${apiVersion}/users/email/${storedId}`;
    const { data } = await axios.post(smsPath);
    return data;
  }

  async registerRequest(userData) {
    const registerPath = `${this.getBaseURL()}${apiVersion}/users/pending-user/add `;
    const { data } = await axios.post(registerPath, userData);
    return data;
  }

  // GET /api/users/login?username=USERNAME&password=PASSWORD
  async login(username, password) {
    if (this.demo) {
      const token = '123';
      this.token = token;
      const user = {
        _id: 'adminUser',
        email: 'abc@def.com',
        name: 'abc',
        enabled: true,
        phoneNum: '+4917172394323',
        registerDate: Date(),
        isAdmin: username === 'admin@admin.com',
      };
      localUsers[0] = user;
      // console.log('Notifying user data change...');
      // this.api.onUserDataChange(user);
      return Promise.resolve({ token, user });
    }

    const params = {
      username: username,
      password: password,
      deviceID: sessionStorage.getItem('userDeviceID'),
    };

    const loginPath = `${this.getBaseURL()}${apiVersion}/users/login`;

    const { data } = await axios.get(loginPath, { params });
    return data;
  }

  // GET /api/users/logout
  async logout() {
    if (!this.api.token) {
      return Promise.resolve();
    }

    if (this.demo) {
      this.api.token = null;
      return Promise.resolve();
    }

    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/users/logout`, { headers });
    return data;
  }

  // DELETE /api/users/:id
  async deleteUser(id, hardDelete = global.deleteMode ? 'yes' : 'no') {
    if (this.demo) {
      const userIndex = localUsers.findIndex(({ _id }) => _id === id);
      if (userIndex === -1) {
        return;
      }
      localUsers.splice(userIndex, 1);
      return Promise.resolve();
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(
      `${this.getBaseURL()}${apiVersion}/users/${id}?hardDelete=${hardDelete}`,
      {
        headers,
      },
    );
    return data;
  }

  // POST /api/v2/companies/:cid/users
  async addUser(companyId, user) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/users`,
      user,
      { headers },
    );
    return data;
  }

  async addBulkUser(usersCSV) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
      'Content-Type': 'multipart/form-data',
    };
    await axios.post(`${this.getBaseURL()}${apiVersion}/users/import/users`, usersCSV, { headers });
  }

  // PUT /api/users/:id {status=STATUS}
  async setUserStatus(id, status = false, type) {
    if (this.demo) {
      const userIndex = localUsers.findIndex(({ _id }) => _id === id);
      if (userIndex === -1) {
        return null;
      }
      localUsers[userIndex].enabled = status;
      return Promise.resolve(localUsers[userIndex]);
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/users/${id}`,
      type === '2FA' ? { twoFactor: status } : { enabled: status },
      { headers },
    );

    return data;
  }

  // GET /api/v2/users/me
  async myInfo() {
    if (this.demo) {
      return Promise.resolve(localUsers[0]);
    }
    if (!this.api.token) {
      return null;
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/users/me`, { headers });
    return data;
  }

  getPaginateOptions = options => {
    return JSON.stringify(options || { page: 1, limit: 10 });
  };

  // GET /api/v2/users/
  async getUsers(
    paginateOptions,
    companyType = 'all',
    role = 'all',
    getDeleted = global.deleteMode,
  ) {
    if (this.demo) {
      return Promise.resolve(localUsers);
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/users/?paginateOptions=${options}&companyType=${companyType}&role=${role}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async filterByEmail(
    id,
    email,
    paginateOptions,
    disablePaginate = 'no',
    role = '',
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    if (disablePaginate === 'yes') {
      const { data } = await axios.get(
        `${this.getBaseURL()}${apiVersion}/companies/${id}/users/${email}?paginateOptions=${disablePaginate}&role=${role}&getDeleted=${getDeleted}`,
        { headers },
      );
      return data;
    }
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${id}/users/${email}?paginateOptions=${options}&role=${role}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async filterByName(
    id,
    name,
    paginateOptions,
    disablePaginate = 'no',
    role,
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${id}/users/filter?type=name&value=${name}&paginateOptions=${options}&disablePaginate=${disablePaginate}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }
  async filterByCompany(
    id,
    paginateOptions,
    disablePaginate = 'no',
    userType = '',
    getDeleted = global.deleteMode,
  ) {
    let companyID;
    if (id.company !== undefined) {
      companyID = id.company;
    } else {
      companyID = id;
    }
    const options = this.getPaginateOptions(paginateOptions);
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${companyID}/users?paginateOptions=${options}&disablePaginate=${disablePaginate}&userType=${userType}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  // GET /api/v2/companies/:id/users
  async getUsersByCompanyId(
    id,
    paginateOptions,
    disablePaginate = 'no',
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    if (disablePaginate === 'no') {
      const { data } = await axios.get(
        `${this.getBaseURL()}${apiVersion}/companies/${id}/users?disablePaginate=${disablePaginate}&getDeleted=${getDeleted}`,
        { headers },
      );
      return data;
    }
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${id}/users?paginateOptions=${options}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getUsersRequests() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/users/pending-user/all`, {
      headers,
    });
    return data;
  }

  async updateUserRequest(body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/users/pending-user/approval`,
      body,
      { headers },
    );
    return data;
  }

  // PUT //api/users/:id
  async updateUserById(id, userObj) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const res = await axios.put(`${this.getBaseURL()}${apiVersion}/users/${id}`, userObj, {
      headers,
    });
    return res;
  }

  async resetPasswordByOld(userId, oldPassword, newPassword, isAutoGenerate, godMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const params = {
      oldPass: oldPassword,
      newPass: newPassword,
      autoGenerate: isAutoGenerate,
      godMode,
    };

    const res = await axios.get(`${this.getBaseURL()}${apiVersion}/users/${userId}/reset`, {
      headers,
      params,
    });
    return res;
  }

  async sendResetMail(email) {
    const res = await axios.get(
      `${this.getBaseURL()}${apiVersion}/users/sendResetMail?email=${email}`,
    );
    return res;
  }

  async resetPassword(email, password, link) {
    const res = await axios.get(
      `${this.getBaseURL()}${apiVersion}/users/resetPassword?email=${null}&password=${encodeURIComponent(
        password,
      )}&link=${link}`,
      null,
      password,
      link,
    );
    return res;
  }

  async onRecover(userId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const data = await axios.patch(
      `${this.getBaseURL()}${apiVersion}/users/${userId}`,
      {
        deleted: false,
      },
      { headers },
    );
    return data;
  }

  async getOverview(getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const res = await axios.get(
      `${this.getBaseURL()}${apiVersion}/users/overview?getDeleted=${getDeleted}`,
      { headers },
    );
    return res.data;
  }

  async getUserAccountLock(userID) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const res = await axios.get(
      `${this.getBaseURL()}${apiVersion}/users/${userID}/accountLockStatus`,
      { headers },
    );
    return res.data;
  }

  async userResetPassword(body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const res = await axios.post(
      `${this.getBaseURL()}${apiVersion}/users/resetUserPassword `,
      body,
      { headers },
    );
    return res.data;
  }

  async userLoginPasswordResetOnLogin(resetValue) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const res = await axios.get(
      `${this.getBaseURL()}${apiVersion}/users/login-reset?resetPassword=${resetValue} `,
      { headers },
    );
    return res.data;
  }

  async getUserLoginHistory(userID, paginateOptions) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const options = this.getPaginateOptions(paginateOptions);

    const res = await axios.get(
      `${this.getBaseURL()}${apiVersion}/users/login-history/${userID}?paginateOptions=${options}`,
      { headers },
    );
    return res.data;
  }
  async getOobLogs(userId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const res = await axios.get(
      `${this.getBaseURL()}${apiVersion}/users/${userId}/oobmSession `,
      { headers },
    );
    return res.data;
  }
  
  async getEnterpriseGroupUser(enterpriseGroupID) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const res = await axios.get(
      `${this.getBaseURL()}${apiVersion}/enterprise-group/${enterpriseGroupID}/users `,
      { headers },
    );
    return res.data;
  }
}

export default UserService;
